import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

export const merchantsAdapter = createEntityAdapter({
  selectId: (merchant: API.Merchant) => merchant.merchant_name,
});

const slice = createSlice({
  name: "merchants",
  initialState: merchantsAdapter.getInitialState(),
  reducers: {
    setMany: merchantsAdapter.setAll,
    setOne: merchantsAdapter.setOne,
    flush: merchantsAdapter.removeOne,
  },
});

export const { actions } = slice;

export default {
  merchants: slice.reducer,
};
